import React from "react";
import { Box } from "@mui/material";

const ImageGallery = ({ images }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
      {/* Vertical Thumbnails (no arrows) */}
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
            maxHeight: 280,
            gap: 1,
            pr: 0.5,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: 4,
            },
          }}>
          {images.secondary.map((img, index) => (
            <Box
              key={index}
              component="img"
              src={img}
              alt={`Secondary ${index}`}
              onClick={() => setActiveIndex(index)}
              sx={{
                width: 60,
                height: 60,
                objectFit: "cover",
                borderRadius: 1,
                cursor: "pointer",
                border:
                  activeIndex === index
                    ? "2px solid #1976d2"
                    : "1px solid #ddd",
              }}
            />
          ))}
        </Box>
      </Box>

      {/* Main Image */}
      <Box
        component="img"
        src={images.secondary[activeIndex] || images.primary}
        alt="Main display"
        sx={{
          width: 400,
          height: 300,
          objectFit: "cover",
          borderRadius: 2,
          border: "1px solid #eee",
        }}
      />
    </Box>
  );
};

export default ImageGallery;
